import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { ReactComponent as Bullet } from "../../assets/images/svg/bullets.svg";
import { ReactComponent as Delete } from "../../assets/images/svg/Delete.svg";
import Swal from "sweetalert2";
import AgentTemplatePopup from "./AgentTemplatePopup";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";

const SelectAgent = (props) => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const [agentData, setAgentData] = useState(props.agent);
  const [currentAgnet, setCurrentAgent] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAgent, setSelectedAgent] = useState([]);
  const [showMenu, setShowMenu] = useState(false);
  const [agentList, setAgentList] = useState([]);
  const [agentList2, setAgentList2] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [ageList, setAgeList] = useState("");
  const [isAgentTemplateOpen, setIsAgentTemplateOpen] = useState(false);
  const axiosprivate = UseAxiosPrivate();

  useEffect(() => {
    setAgentData(props.agent);
  }, [props.agent]);

  useEffect(()=>{
    const agents = agentData.map(item => ({
      id: item.id,
      agent_name: item.profile_name
    }));
    // console.log(agents)
    setAgentList2(agents);
  },[])

  const dropdownRef = useRef(null);

  const AddScheduleTemplate = () => {
    setIsAgentTemplateOpen(true);
  }

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setShowMenu(true);
  };


  const toggleMenu = () => {
    if(agentList?.length<=0){
      Swal.fire(
        'Warning!',
        `Currently, no Agent templates are available. </br>Click <span style="color:red">"Agent Template"</span> to create one.`,
        'warning'
      );
    }else{
      setShowMenu(!showMenu);
    }
  };

  const handleBlur = () => {
    // Delay hiding menu to allow option selection
    setTimeout(() => setShowMenu(false), 150);
  };

  const fetchAgentTeamplates=async()=>{
        try{
            const res = await axiosprivate.get(`${process.env.REACT_APP_API_URL}/contactcentre/agent_template/`)
            
            if(res.status==200){
              // alert(res.data)
              setAgentList(res.data)
            }
          }catch(error){
            Swal.fire(
              'Warning!',
              `${error.response.data?.error || 'Something Went wrong. Try Again.'}`,
              'warning'
            );
  
        }
    }

  const filteredOptions = agentList.filter(option =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOptionSelect = async(option) => {
      // alert(option.id)
      setSelectedOption(option);
      setSearchTerm(option.name); // Show selected label in input
      setShowMenu(false); // Hide menu after selection

      props.setAgentDataChanged(true);
  
      try{
        const res = await axiosprivate.get(`${process.env.REACT_APP_API_URL}/contactcentre/agent_template_agents/${option.id}`)
        
        if(res.status===200){
          setAgeList(res.data)
          let templateAgents = res?.data || [];
          if (props.is_whatsapp) {
            const skipped = templateAgents.filter(el => el.call_mode !== 'sip');
            templateAgents = templateAgents.filter(el => el.call_mode === 'sip');
            if (skipped.length > 0) {
              Swal.fire({
                icon: 'warning',
                title: 'Some Agents Skipped',
                text: `${skipped.length} agent(s) from this template were skipped because WhatsApp campaigns require SIP call mode.`,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok',
              });
            }
          }
          const agentIds = templateAgents.map(el => el.id);
          setSelectedAgent(agentIds);
          props.setData(prev => ({
            ...prev,
            agents: agentIds
          }));
          
          setSearchTerm('');
        }
  
      }catch(error){
        setSearchTerm('');
        Swal.fire(
          'Warning!',
          `${error.response.data?.error || 'Something Went wrong. Try Again.'}`,
          'warning'
        );
      }
  
      
    };
  
  const filteredAgents = useMemo(() => {
    // selectedAgent is already an array of IDs
    const selectedAgentsIds = new Set(selectedAgent || []);

    if (!searchTerm) {
      return agentData.filter(agent => !selectedAgentsIds.has(agent.id));
    }

    const term = searchTerm.toLowerCase();

    return agentData.filter(agent => {
      // exclude selected agents
      if (selectedAgentsIds.has(agent.id)) return false;

      const name = agent.profile_name ?? "";

      return name.toLowerCase().includes(term);
    });
  }, [searchTerm, agentData, selectedAgent]);


  useEffect(() => {
    setSelectedAgent(Array.isArray(props.agents) ? props.agents : []);
  }, [props.agents]);


  const handleDelete = (obj, index) => {
    Swal.fire({
      title: "Are you sure to Delete?",
      text: "All your details about the campaign will be deleted",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        props.agents.splice(index, 1);
        setSelectedAgent((current) => current.filter((item) => item !== obj));
      }
    });
  };

  const sendAgentDataToNewCampaign = () => {
    if (props.agents.length !== 0) {
      props.setActive(props.next);
    } else {
      Swal.fire({
        icon: "error",
        title: "Campaign Creation Failed",
        text: "Please select an agent for the campaign.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ok",
      })
      return;
    }
  };

  const availableAgents = useMemo(() => {
    return (agentData?.length || 0) - (selectedAgent?.length || 0);
  }, [agentData, selectedAgent]);

  useEffect(() => {
    if (availableAgents === 0) {
      setIsDropdownOpen(false);
    }
  }, [availableAgents]);


  // Handle clear all selected Agents
  const handleClearAll = useCallback(() => {
      setSelectedAgent([]);
      props.setData((preState) => ({
        ...preState,
        agents: [],
      }));
  } );

  useEffect(() => {
      fetchAgentTeamplates();

      const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
              setIsDropdownOpen(false);
          }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
          document.removeEventListener('mousedown', handleClickOutside);
      };
  }, []);

  const handleSelectAllAgents = useCallback(() => {
    const selectedIds = new Set(selectedAgent);

    let eligibleAgents = filteredAgents.filter(a => !selectedIds.has(a.id));

    if (props.is_whatsapp) {
      const skipped = eligibleAgents.filter(a => a.call_mode !== 'sip');
      eligibleAgents = eligibleAgents.filter(a => a.call_mode === 'sip');
      if (skipped.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Some Agents Skipped',
          text: `${skipped.length} agent(s) were skipped because WhatsApp campaigns require SIP call mode.`,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        });
      }
    }

    const agentsToAdd = eligibleAgents.map(a => a.id);

    if (agentsToAdd.length === 0) return;

    const newSelectedAgents = [...selectedAgent, ...agentsToAdd];

    setSelectedAgent(newSelectedAgents);

    // Update parent state
    props.setData(prevState => ({
      ...prevState,
      agents: newSelectedAgents
    }));

    // Clear search & close dropdown
    setSearchTerm("");
    setIsDropdownOpen(false);

  }, [selectedAgent, filteredAgents, props.setData]);


  const handleChange = (id) => {

    setCurrentAgent(id);

    if (props.is_whatsapp) {
      const agentObj = agentData.find(a => a.id === id);
      if (agentObj && agentObj.call_mode !== 'sip') {
        Swal.fire({
          icon: 'warning',
          title: 'Invalid Agent',
          text: `"${agentObj.profile_name}" cannot be added. WhatsApp campaigns require agents with SIP call mode.`,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        });
        setSearchTerm('');
        return;
      }
    }

    const isFound = selectedAgent.some((element) => {
      if (id === "") {
        return true;
      }
      if (element === id) {
        return true;
      } else {
        return false;
      }
    });

    if (isFound) {
      console.log("This Agent Already Added");
    } else {
      setSelectedAgent((prevItems) => [...prevItems, id]);

      props.setData((preState) => ({
        ...preState,
        agents: [...preState.agents, id],
      }));
    }
    setSearchTerm("");
  };

  // console.log("AgentData -----> ", agentData);

  return (
    <div className="max-w-5xl p-6 ml-5">

      <AgentTemplatePopup
        isTempOpen={isAgentTemplateOpen}
        onClose={() => setIsAgentTemplateOpen(false)}
        setData={props.setData}
        scheduleTime={props?.scheduleTime}
        ageList={ageList}
        setAgeList={setAgeList}
        agentList={agentList}
        agentList2={agentList2}
        setAgentList={setAgentList}
        setAgentList2={setAgentList2}
        fetchAgentTeamplates={fetchAgentTeamplates}
        props={props}
      />

      <p className="text-sm text-slate-400">Step 2/7</p>
      <h1 className="text-lg font-bold">Let's Select Agent</h1>
      <p className="text-sm text-slate-400 border-b-2 pb-8">
        Please select the agents, so that we can create new campaign
      </p>
      {/* <h1 className="text-md text-slate-400 pt-8">Agents</h1>
      <div className="relative w-full flex space-x-2">
        <select
          className="w-full h-12 p-2.5 text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-black"
          value={currentAgnet}
          onChange={handleChange}
        >
          <option value={""}></option>
          {agentData.map((d) => (
            <option key={d.id} value={d.id} name="agent">
              {d.profile_name}
            </option>
          ))}
        </select>
      </div> */}

      <div className="flex item-center justify-between">

        <div className="w-[48%]">

          <div className="flex items-center justify-between mb-0 mt-5">
              <label className="block text-md text-slate-600 font-medium mb-3 flex items-center gap-2">
                  <Bullet />
                  Available Agents ({availableAgents.length} remaining)
              </label>
              {selectedAgent.length > 0 && (
                  <button
                      onClick={handleClearAll}
                      className="text-sm text-red-500 hover:text-red-700 font-medium"
                  >
                      Clear All ({selectedAgent.length})
                  </button>
              )}
          </div>
          

          {/* Multi-Select Dropdown */}
          <div className="relative" ref={dropdownRef}>
              <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  disabled={agentData.length-selectedAgent.length === 0}
                  className="w-full h-12 px-4 py-2.5 text-left text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 flex items-center justify-between disabled:bg-gray-100 disabled:cursor-not-allowed"
              >
                  <span>
                        {selectedAgent
                          ? `Select Agents (${selectedAgent.length} selected)`
                          : "Select Agents (0 selected)"
                        }
                  </span>
                  <svg
                      className={`w-5 h-5 transition-transform duration-200 `}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                  >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
              </button>

              {/* Dropdown Content */}
              {isDropdownOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-84 overflow-hidden">
                      {/* Search Input */}
                      <div className="p-3 border-b border-gray-200">
                          <input
                              type="text"
                              placeholder="Search Agents..."
                              onChange={(e)=>setSearchTerm(e.target.value)} 
                              value={searchTerm}                         
                              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-200"
                          />
                      </div>

                      {/* Select All Option */}
                      
                          <div className="px-3 py-2 border-b border-gray-100">
                              <button
                                  onClick={handleSelectAllAgents}
                                  className="w-full text-left text-sm text-blue-600 hover:text-blue-800 font-medium"
                              >
                                  Select All Filtered 
                              </button>
                          </div>
                      

                      {/* DID Options */}
                      <div className="max-h-48 overflow-y-auto">
                        
                              {agentData.length===0? (
                              <div className="px-3 py-4 text-sm text-gray-500 text-center">
                                  {"No Agents match your search"}
                              </div>

                              )
                              : 
                              (
                                (filteredAgents.map((d) => (
                                    <button 
                                      onClick={()=>{handleChange(d.id)}}
                                      key={d.id} 
                                      // value={d.id} 
                                      name="agent"
                                      className="searchFilterClass  w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-150 border-b border-gray-50 last:border-b-0"
                                    >
                                        <span className="font-mono">{d.profile_name}</span>
                                    </button>
                                )))

                              )
                            }
                        
                                  
                      </div>
                  </div>
              )}
          </div>
        </div>

        <div className="w-[48%] flex items-center jistify-between">

              <div className="selectAgentTemplate">

                  <div className="flex items-center justify-between mb-0 mt-5">
                      <label className="block text-md text-slate-600 font-medium mb-3 flex items-center gap-2">
                          <Bullet />
                          Select Agent Template
                      </label>
                  </div>

                  <div className="relative w-[25rem]">
                      {/* Searchable Input */}
                      <input
                        type="text"
                        value={searchTerm}
                        onChange={handleInputChange}
                        onClick={toggleMenu}
                        onBlur={handleBlur}
                        placeholder="Select Agent Template"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 active:border-blue-500 block w-full pl-10 p-[0.8rem] rounded-tr-none rounded-br-none"
                      />
                      <div className="absolute left-[0.75rem] right-[0rem] top-[0.75rem] z-10 w-[1.4rem] h-[1.4rem]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="#00000051"
                          strokeWidth={2.5}
                        >
                          <circle cx="12" cy="8" r="4" />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M4 20c0-4 4-6 8-6s8 2 8 6"
                          />
                        </svg>
                      </div>

                      {/* Dropdown Menu */}
                      {showMenu && (
                        <ul
                          className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10"
                          onMouseDown={(e) => e.preventDefault()} // Prevent input blur when interacting with dropdown
                        >
                          {filteredOptions.map((option) => (
                            <li
                              key={option.value}
                              onClick={() => handleOptionSelect(option)} // Handle option selection
                              className="cursor-pointer py-2 px-4 hover:bg-gray-200"
                            >
                              {option.name}
                            </li>
                          ))}
                          {filteredOptions.length === 0 && (
                            <li className="py-2 px-4 text-gray-500">No options found</li>
                          )}
                        </ul>
                      )}
                  </div>
              </div>

              <div className="AddAgentTemplates ">
                  <button
                    type="button"
                    onClick={AddScheduleTemplate}
                    className="bg-gradient-to-b from-green-400 via-green-500 to-blue-400 px-3 py-3 mt-[3.5rem] ml-[0.25rem] rounded-md  text-white text-sm font-medium  transition duration-200 rounded-tl-none rounded-bl-none"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-5 h-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                     
                  </button>
              </div>
        </div>

      </div>


      {props.agents.length !== 0 && (
        <div className="relative overflow-x-auto mt-12">
          <table className="min-w-full text-sm text-left">
            <thead className="bg-gray-50 border-b">
              <tr>
                <th className="px-6 py-4 font-medium text-gray-700">No.</th>
                <th className="px-6 py-4 font-medium text-gray-700">Agents</th>
                <th className="px-6 py-4 font-medium text-gray-700">Action</th>
              </tr>
            </thead>
            <tbody>
              {selectedAgent.map((obj, index) => (
                <tr key={obj} className="border-b hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 font-medium text-gray-900">
                    {index + 1}
                  </td>
                  <td className="px-6 py-4 text-gray-700 font-mono">
                    {" "}
                    {agentData == []
                      ? []
                      : agentData.filter((agent) => agent.id == obj)[0]
                        ?.profile_name || "".profile_name}
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => handleDelete(obj, index)}
                      className="inline-flex items-center justify-center w-8 h-8 rounded-full text-red-500 hover:bg-red-50 hover:text-red-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-red-200"
                      aria-label={`Delete Agent ${obj}`}
                      title="Delete Agent"
                    >
                      <Delete
                        className="w-4 h-4"
                        fill="#b30000ff"
                        style={{ color: '#b30000ff' }}
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="pt-8 flex justify-between items-end">
        <button
          className="px-8 py-3 font-semibold text-gray-800 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
          onClick={() => {
            props.setActive(props.back);
          }}
        >
          Back
        </button>
        <button
          className={`font-bold text-lg rounded-full w-36 h-12`}
          style={{
            backgroundImage:
              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
            color: "white",
          }}
          
          onClick={sendAgentDataToNewCampaign}
        >
          Next Step
        </button>
      </div>
    </div>
  );
};

export default SelectAgent;
